import { Injectable, inject } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { LocalStorageService } from '../storage/local-storage.service';

@Injectable({
  providedIn: 'root',
})
export class AuthStateService {
  localStorage = inject(LocalStorageService);

  private loggedInSubject = new BehaviorSubject<boolean>(
    !!this.localStorage.get('token')
  );
  isLoggedIn = this.loggedInSubject.asObservable();

  set(newValue: boolean) {
    this.loggedInSubject.next(newValue);
  }
}
